<template>
    <div class="top-info">
        <div class="info-row with-addon patient-info">
            <div class="info-addon">
                <img :src="genderIcon" :alt="genderAltText" />
            </div>
            <div>
                <strong>{{ patient.fullName }}</strong><br />
                <small>{{ $dateFormat.humanDate(patient.birthDate) }}</small>
            </div>
        </div>

        <div class="info-row with-addon drug-info">
            <div class="info-addon">
                <img src="@/assets/pictos/drug-pills.svg" alt="" />
            </div>
            <div>
                <strong v-if="requestData.isDrugNameSelected">{{ requestData.selectedDrugName }}</strong>
                <i v-else><strong>{{ $t('general.noDrugSelected') }}</strong></i>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { PatientGender, usePatientStore } from '@/store/patient';
import { useRequestDataStore } from '@/store/request-data';
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n';

export default defineComponent({
    setup() {
        const translator = useI18n();
        const patient = usePatientStore();
        const requestData = useRequestDataStore();

        const genderIcon = computed(() => {
            if (patient.gender === PatientGender.Male) {
                return require("@/assets/pictos/genders/male.svg");
            }

            if (patient.gender === PatientGender.Female) {
                return require("@/assets/pictos/genders/female.svg");
            }

            return require("@/assets/pictos/genders/unknown.svg");
        });

        const genderAltText = computed(() => {
            if (patient.gender === null) {
                return translator.t('gender.unknown');
            }

            return translator.t(`gender.${patient.gender}`);
        });

        return { patient, requestData, genderIcon, genderAltText };
    },
})
</script>

<style lang="scss" scoped>

.top-info {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding: 1.25rem 2rem 1.25rem 1rem;
    font-size: 1.15rem;
    background-color: $gray-400;
    color: $white;

    //
    // Styles for the arrow on the right
    //
    &::after {
        content: "";
        position: absolute;
        top: calc(50% - 0.625rem);
        left: 100%;
        width: 0.625rem;
        height: 1.25rem;
        background-color: $gray-400;
        z-index: 10;
        clip-path: polygon(0% 0%, 100% 50%, 0% 100%);    // A triangle
    }

    //
    // Inner blocks styles
    //
    .info-row {
        position: relative;

        &.with-addon {
            padding-left: 2rem;
        }

        .info-addon {
            position: absolute;
            top: 0;
            left: 0;

            & > img {
                width: 1.25rem;
                height: auto;
            }
        }
    }
}

</style>

